// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateProcessingCost_createButton__b1Ypi","formItem":"CreateProcessingCost_formItem__mV24N","buttonsContainer":"CreateProcessingCost_buttonsContainer__2WA0r"};